const SET_LOGIN_API = 'login/SET_LOGIN_API';
const SET_LOGIN_SUCCESSS = 'login/SET_LOGIN_SUCCESSS';
const GET_LOGIN_API = 'GET_LOGIN_API'
export {
    SET_LOGIN_API,
    SET_LOGIN_SUCCESSS,
    GET_LOGIN_API
}